import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { ADD_FORM_NAME } from 'presentations/constants';
import AddStepParticipants from 'presentations/components/add_step_participants';

const mapStateToProps = (state) => {
  const selector = formValueSelector(ADD_FORM_NAME);
  const weightVotes = selector(state, 'weight_votes');

  return {
    weightVotes
  };
}

export default connect(mapStateToProps)(AddStepParticipants);



// WEBPACK FOOTER //
// ./presentations/containers/add_step_participants.js